<template>
  <div class="plan" :class="{ 'plan--current': isCurrent }">
    <div class="plan__hue bg-plan-scale" />
    <section class="pa-6">
      <div class="text-h4 font-weight-bold mb-3 text-plan-scale">{{ pricePlan.name }}</div>
      <div class="mb-5 text-body-2" data-subtitle>{{ $t('business.plans.scale.lead') }}</div>
      <div class="text-h4 text-grey-darker font-weight-bold mb-6">
        {{ $t('business.plans.scale.talk') }}
      </div>
      <v-btn v-if="isCurrent" color="info" size="large" block disabled>{{ $t('business.plan.current_plan') }}</v-btn>
      <v-btn
        v-else
        color="info"
        size="large"
        block
        variant="outlined"
        :href="$t('business.plans.scale.cta.link')"
        target="_blank"
      >
        {{ $t('business.plans.scale.cta.text') }}
      </v-btn>
      <v-divider class="mt-6 mb-3" />
      <div class="d-flex align-center">
        <span>{{ $t('business.plan.scale.info') }}</span>
      </div>
      <v-divider class="mt-3 mb-6" />
      <p v-for="(feature, index) in features" :key="index">
        <span>{{ feature.text }}</span>
        <span v-if="feature.footnote" class="superscript font-weight-semibold">{{ feature.footnote }}</span>
        <v-tooltip v-if="feature.tooltip" location="right" content-class="bg-info" :open-on-click="true">
          <template #activator="{ props }">
            <v-icon class="ml-1" color="text" size="16" v-bind="props">custom:c_question</v-icon>
          </template>
          <span class="whitespace-pre-wrap">{{ feature.tooltip }}</span>
        </v-tooltip>
      </p>
    </section>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default defineComponent({
  props: {
    pricePlan: {
      type: Object as PropType<Omit<PricePlan, 'yearly' | 'monthly'>>,
      required: true,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      features: [
        { text: this.$t('plan.features.mix_signatures.text'), tooltip: this.$t('plan.features.qualities_tooltip') },
      ],
    }
  },
})
</script>

<style lang="sass" scoped>
.plan
  width: 296px
  box-shadow: 0px 9px 16px 1px rgba(40, 62, 102, 0.19)
  border-radius: 4px
  overflow: hidden
  background-color: $c-white
  &--current
    box-shadow: 0px 2px 5px rgba(40, 62, 102, 0.19)
  &__hue
    height: 12px
  [data-subtitle]
    min-height: 40px

.superscript
  position: relative
  bottom: 0.375em
  font-size: 0.75em
</style>
